import React from "react";
import { Link } from "react-router-dom";

// (Components)
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

// (Image)
import StakingOptions from "../components/StakingOptions";
import Spacer from "../components/Spacer";

const HomePage = () => {
  return (
    <main className="home-page w-full flex flex-col gap-y-4" id="banner">
      {/* NAVBAR HEADER */}
      <header>
        <Navbar />
      </header>

      {/* CHOOSE CONNECT OPTION */}
      <section className="w-full relative min-w-full max-w-full pb-6">
        <div className="w-full max-w-full md:max-w-[1200px] mx-auto">
          <div className="w-full relative text-wrap">
            <div className="w-full relative overflow-hidden bg-[rgba(101,103,238,0.1)] rounded-3xl p-6">
              <div className="w-full relative flex flex-col gap-6">
                <div className="w-full grid grid-cols-1 md:grid-cols-[1fr_0.3fr]">
                  <div className="w-full flex flex-col gap-6">
                    <h2 className="text-4xl md:text-6xl font-semibold">
                      The world’s most popular crypto wallets
                    </h2>
                    <p className="text-lg md:text-xl font-medium">
                      Over 76 million wallets created to buy, sell, and earn
                      crypto.
                    </p>
                    <div className="w-auto flex">
                      <Link to={`/account`}>
                        <button className="bg-[#2A59F7] text-white py-4 px-10 font-medium rounded-lg flex gap-1 justify-center items-center">
                          <span>Synchronize Wallet</span>
                        </button>
                      </Link>
                    </div>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* STAKING OPTION */}
      <section className="w-full min-w-full max-w-full pb-6">
        <StakingOptions />
      </section>

      <div className="w-full relative flex flex-col gap-6">
        <Spacer>
          <div className="w-full relative flex flex-col gap-6 bg-[#2A59F7] rounded-xl">
            <div className="w-full flex flex-col justify-center items-center gap-3 py-10">
              <h2 className="text-4xl md:text-xl font-semibold">
                READY TO START
              </h2>
              <p className="text-lg md:text-4xl font-medium">
                Synchronize your Wallet
              </p>
              <div className="w-auto flex">
                <Link to={`/account`}>
                  <button className="bg-blue-200 text-base text-[#0e0e10c9] py-3 px-6 font-medium rounded-lg flex gap-1 justify-center items-center">
                    <span>Get Started</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </Spacer>
      </div>

      {/* FOOTER */}
      <section className="w-full min-w-full max-w-full pb-6">
        <Footer />
      </section>
    </main>
  );
};

export default HomePage;
